import {SampleHarvestType} from 'types/model/enumeration/SampleHarvestType';
import {SelectOptions} from 'forms/components/BasicSelect';

export const sampleHarvestTypeOptions: SelectOptions<SampleHarvestType> = [
    {value: 'DAIRY', label: 'Mlékárna'},
    {value: 'VETERINARY', label: 'Veterinář'},
    {value: 'PRIMARY_PRODUCER', label: 'Prvovýrobce'},
];
